<div [routerLink]="['/subboard', 'club', model.clubId, 'request', model.id]" class="request-list-item-container">
    <app-substitution-request-list-item-body [model]="model" [showStatus]="showStatus">
    </app-substitution-request-list-item-body>
</div>